import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { AUTH_STATUS_NEW } from "constants/FormatDataContanst";
import {
  ISSUE_INVOICE_BUYER_FIELD,
  LINK_TYPE,
  MODE_INVOICE_ACTION,
  TYPE_ACTION_WORKFLOW,
  TYPE_INVOICE_ANOTHER,
} from "constants/IssueInvoiceConstant";
import { base64toBlob, errorMessage } from "helpers/utils";
import moment from "moment";
import { FIELD_CUSTOMER } from "pages/GeneralInfo/Customer/utils";
import { TYPE_AUTO_RELOAD } from "pages/IssueInvoice/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import CustomerService from "services/CustomerService";
import DashboardService from "services/DashboardService";
import IssueInvoiceService from "services/IssueInvoiceService";
import {
  createIssueInvoiceFail,
  createIssueInvoiceSuccess,
  downloadXmlIssueInvoiceFail,
  downloadXmlIssueInvoiceSuccess,
  editIssueInvoiceFail,
  editIssueInvoiceSuccess,
  generateNumberInvoiceFail,
  generateNumberInvoiceSuccess,
  getDetailIssueInvoiceFail,
  getDetailIssueInvoiceSuccess,
  getEnterpriseByTaxCodeFail,
  getEnterpriseByTaxCodeSuccess,
  listIssueInvoiceFail,
  listIssueInvoiceSuccess,
  loadConfigInvoiceFieldFail,
  loadConfigInvoiceFieldSuccess,
  releaseIssueInvoiceFail,
  releaseIssueInvoiceSuccess,
  setMethodSignSuccess,
  transferUsbInvoiceFail,
  transferUsbInvoiceSuccess,
} from "store/actions";
import {
  actionWorkflowIssueInvoiceFail,
  actionWorkflowIssueInvoiceSuccess,
  adjustIssueInvoiceFail,
  adjustIssueInvoiceSuccess,
  backupDataNew,
  cancelIssueInvoiceFail,
  cancelIssueInvoiceSuccess,
  createIssueInvoiceEnterpriseAdjustAllFail,
  createIssueInvoiceEnterpriseAdjustAllSuccess,
  createIssueInvoiceEnterpriseFail,
  createIssueInvoiceEnterpriseSuccess,
  deleteIssueInvoiceFail,
  deleteIssueInvoiceSuccess,
  downloadZipInvoiceFail,
  downloadZipInvoiceSuccess,
  exportInvoiceFail,
  exportInvoiceSuccess,
  exportInvoiceTicketFail,
  exportInvoiceTicketSuccess,
  exportInvoiceWarehousesAgencyFail,
  exportInvoiceWarehousesAgencySuccess,
  exportInvoiceWarehousesFail,
  exportInvoiceWarehousesSuccess,
  getCloneEnvoiceFail,
  getCloneEnvoiceSuccess,
  getCurrentTimeFail,
  getCurrentTimeSuccess,
  getDataLinkFail,
  getDataLinkSuccess,
  getInvoiceCampaignListFail,
  getInvoiceCampaignListSuccess,
  getInvoiceMaxDateFail,
  getInvoiceMaxDateSuccess,
  getInvoiceMinDateFail,
  getInvoiceMinDateSuccess,
  getInvoiceReportWordFail,
  getInvoiceReportWordSuccess,
  invoiceCampaignDetailFail,
  invoiceCampaignDetailSuccess,
  previewPdfIssueInvoiceFail,
  previewPdfIssueInvoiceSuccess,
  releaseCampaignsInvoiceFail,
  releaseCampaignsInvoiceSuccess,
  replaceIssueInvoiceFail,
  replaceIssueInvoiceSuccess,
  sendMailInvoiceFail,
  sendMailInvoiceSuccess,
  uploadAttackFileInvoiceFail,
  uploadAttackFileInvoiceSuccess,
  uploadCampaignsInvoiceFail,
  uploadCampaignsInvoiceSuccess,
  uploadFileInvoiceFail,
  uploadFileInvoiceSuccess,
} from "./actions";
import {
  ACTION_WORKFLOW_ISSUE_INVOICE,
  ADJUST_ISSUE_INVOICE,
  ATTACK_FILE_INVOICE_UPLOAD,
  CANCEL_ISSUE_INVOICE,
  CLONE_ENVOICE,
  CREATE_ISSUE_INVOICE_ENTERPRISE,
  CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL,
  DELETE_ISSUE_INVOICE,
  DOWNLOAD_XML_ISSUE_INVOICE,
  DOWNLOAD_ZIP_INVOICE,
  EXPORT_INVOICE,
  EXPORT_INVOICE_TICKET,
  EXPORT_INVOICE_WAREHOUSES,
  EXPORT_INVOICE_WAREHOUSES_AGENCY,
  GENERATE_NUMBER_INVOICE,
  GET_CURRENT_TIME,
  GET_DATA_LINK,
  GET_ENTERPRISE_BY_TAX_CODE,
  GET_INVOICE_MAX_DATE,
  GET_INVOICE_MIN_DATE,
  GET_INVOICE_REPORT_WORD,
  INVOICE_CAMPAIGN_DETAIL,
  INVOICE_CAMPAIGN_LIST,
  ISSUE_INVOICE_CREATE,
  ISSUE_INVOICE_DETAIL,
  ISSUE_INVOICE_EDIT,
  ISSUE_INVOICE_LIST,
  LOAD_CONFIG_INVOICE_FIELD,
  PREVIEW_PDF_ISSUE_INVOICE,
  RELEASE_CAMPAIGNS_INVOICE,
  RELEASE_ISSUE_INVOICE,
  REPLACE_ISSUE_INVOICE,
  SEND_MAIL_INVOICE,
  TRANSFER_USB_INVOICE,
  UPLOAD_CAMPAIGNS_INVOICE,
  UPLOAD_FILE_INVOICE,
} from "./actionTypes";

function* getCloneEnvoice({
  id,
  typeInvoiceAnother,
  approveStatus = undefined,
}) {
  try {
    let response = null;
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(IssueInvoiceService.cloneInvoiceWarehouses, id);
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(IssueInvoiceService.cloneWarehousesAgency, id);
    } else {
      response = yield call(
        IssueInvoiceService.cloneEnvoice,
        id,
        approveStatus
      );
    }
    yield put(getCloneEnvoiceSuccess(response));
  } catch (error) {
    yield put(getCloneEnvoiceFail(errorMessage(error)));
  }
}

function* sendMailInvoice({ id, listEmail }) {
  try {
    let response = null;
    response = yield call(IssueInvoiceService.sendMailInvoice, id, listEmail);
    if (response.result) {
      yield put(
        backupDataNew({
          id,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_SEND_MAIL,
        })
      );
      yield put(sendMailInvoiceSuccess());
    } else {
      yield put(sendMailInvoiceFail("Gửi mail thất bại"));
    }
  } catch (error) {
    yield put(sendMailInvoiceFail(errorMessage(error)));
  }
}

function* fetchListIssueInvoice({ payload, typeInvoiceAnother }) {
  try {
    let response = null;
    let { finalListBuCode, listBuOfTenant, buStoreHeader, buTenantHeaderInfo } =
      yield select(state => state.Dashboard);
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        IssueInvoiceService.listIssueInvoiceTickets,
        payload,
        bu_code,
        bu_parent
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        IssueInvoiceService.listDeliveryBill,
        payload,
        bu_code,
        bu_parent
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(
        IssueInvoiceService.listWarehouseAgency,
        payload,
        bu_code,
        bu_parent
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TOTAL) {
      response = yield call(
        IssueInvoiceService.listPendingBills,
        payload,
        bu_code,
        bu_parent
      );
      let i = 0;
      response.items = response.items.map(item => {
        i++;
        return {
          index: i,
          ...item,
        };
      });
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.ERROR_TCT) {
      response = yield call(
        IssueInvoiceService.listInvoiceTCTError,
        payload,
        bu_code,
        bu_parent
      );
    } else if (
      typeInvoiceAnother === TYPE_INVOICE_ANOTHER.ERROR_DELIVERY_BILL_TCT
    ) {
      response = yield call(
        IssueInvoiceService.listDeliveryBillTCTError,
        payload,
        bu_code,
        bu_parent
      );
    } else if (
      typeInvoiceAnother === TYPE_INVOICE_ANOTHER.ERROR_WAREHOUSE_AGENCY_TCT
    ) {
      response = yield call(
        IssueInvoiceService.listWareHouseAgencyTCTError,
        payload,
        bu_code,
        bu_parent
      );
    } else {
      response = yield call(
        IssueInvoiceService.listIssueInvoice,
        payload,
        bu_code,
        bu_parent
      );
    }
    yield put(listIssueInvoiceSuccess(response));
  } catch (error) {
    yield put(listIssueInvoiceFail(errorMessage(error)));
  }
}

function* fetchDetailIssueInvoice({
  id,
  typeInvoiceAnother,
  data = null,
  isAdjustDecrease,
}) {
  try {
    let response = null;
    let responseLink = null;
    let responseAdjustLimit = null;
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
      response = yield call(IssueInvoiceService.detailInvoiceTickets, id);
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(IssueInvoiceService.detailDeliveryBill, id);
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(IssueInvoiceService.detailWarehouseAgency, id);
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TOTAL) {
      const viewPendingBill = yield call(
        IssueInvoiceService.viewPendingBill,
        data
      );
      const detailPendingBill = yield call(
        IssueInvoiceService.detailPendingBill,
        data
      );
      response = {
        detailPendingBill: detailPendingBill,
        businessUnit: {
          ...viewPendingBill.businessUnit,
          invoice_template_code: viewPendingBill.item.invoice_template_code,
          serial: viewPendingBill.item.serial,
          soHd: "Chưa cấp số",
        },
        customer: {
          ...viewPendingBill.customer,
          payment_method_code: viewPendingBill.item.payment_method_code,
          currency_code: viewPendingBill.item.currency_code,
        },
        item: viewPendingBill.item,
      };
    } else {
      response = yield call(IssueInvoiceService.detailIssueInvoice, id);
    }

    if (response) {
      // Get thông tin hoa don thay the /dieu chinh
      let idRootAdjust = id;
      let invoiceAdjustUpdateLimit = 0;
      if (
        typeInvoiceAnother !== TYPE_INVOICE_ANOTHER.INVOICE_TOTAL &&
        response?.link_type
      ) {
        let isGetChild = false;
        switch (response?.link_type) {
          // Parent có field này
          case LINK_TYPE.PARENT_REPLACE:
          case LINK_TYPE.PARENT_ADJUST:
            isGetChild = true;
            break;
          // Child có field này
          case LINK_TYPE.CHILD_REPLACE:
          case LINK_TYPE.CHILD_ADJUST:
            isGetChild = false;
            break;
          default:
            break;
        }
        responseLink = yield call(
          IssueInvoiceService.getDataLink,
          response.id,
          isGetChild
        );
        if (responseLink) {
          if (isGetChild) {
            response.child = responseLink;
          } else {
            response.root = responseLink;
            idRootAdjust = responseLink.id;
            invoiceAdjustUpdateLimit = Number(response.ttoan_tgtttbso);
          }
        }
      }
      // Nếu là điều chỉnh giảm
      if (isAdjustDecrease) {
        responseAdjustLimit = yield call(
          IssueInvoiceService.getAdjustLimit,
          idRootAdjust
        );
        response.limit =
          Number(responseAdjustLimit.limit) - invoiceAdjustUpdateLimit;
      }
      yield put(getDetailIssueInvoiceSuccess(response));
    } else {
      yield put(getDetailIssueInvoiceFail("Lỗi"));
    }
  } catch (error) {
    yield put(getDetailIssueInvoiceFail(errorMessage(error)));
  }
}

function* onCreateIssueInvoice({ payload, typeInvoiceAnother }) {
  try {
    let response = null;
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const data = payload.data;
    // lưu thông tin kh để sủ dụng lại
    if (data.isSaveInfoCustomer) {
      const saveInfoCustomer = {
        [FIELD_CUSTOMER.TEN]: data[ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN.field],
        [FIELD_CUSTOMER.MST]: data[ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field],
        [FIELD_CUSTOMER.DCHI]: data[ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field],
        [FIELD_CUSTOMER.MA]: data[ISSUE_INVOICE_BUYER_FIELD.NMUA_MKHANG.field],
        [FIELD_CUSTOMER.SDTHOAI]:
          data[ISSUE_INVOICE_BUYER_FIELD.NMUA_SDTHOAI.field],
        [FIELD_CUSTOMER.DCTDTU]:
          data[ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field],
        [FIELD_CUSTOMER.STKNHANG]:
          data[ISSUE_INVOICE_BUYER_FIELD.NMUA_STKNHANG.field],
        [FIELD_CUSTOMER.TNHANG]:
          data[ISSUE_INVOICE_BUYER_FIELD.NMUA_TNHANG.field],
        [FIELD_CUSTOMER.TYPE_ID]: "1", // 1 doanh nghiệp, 2 khách lẻ
      };
      yield call(CustomerService.createCustomer, saveInfoCustomer);
    }
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        IssueInvoiceService.createIssueInvoiceTickets,
        payload,
        buStoreHeader
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        IssueInvoiceService.createDeliveryBill,
        payload,
        buStoreHeader
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(
        IssueInvoiceService.createWarehouseAgency,
        payload,
        buStoreHeader
      );
    } else {
      response = yield call(
        IssueInvoiceService.createIssueInvoice,
        payload,
        buStoreHeader
      );
    }
    // Wait XML generate
    yield sleep(1);
    yield put(
      backupDataNew({ ...response, typeAutoReload: TYPE_AUTO_RELOAD.IS_NEW })
    );
    yield put(createIssueInvoiceSuccess(response));
  } catch (error) {
    yield put(createIssueInvoiceFail(errorMessage(error)));
  }
}

function* onEditIssueInvoice({ payload, id, typeInvoiceAnother, auto_sign }) {
  try {
    // Check điều kiện khi edit hóa đơn
    let responseCheckStatus = yield call(
      IssueInvoiceService.checkInvoiceStatus,
      id
    );
    if (responseCheckStatus.invoice.auth_status !== AUTH_STATUS_NEW) {
      yield put(
        editIssueInvoiceFail(
          "Hóa đơn đã được gửi phát hành, bạn không được quyền cập nhật"
        )
      );
      return;
    }

    let response = null;
    const data = payload.data;
    // lưu thông tin kh để sủ dụng lại
    if (data.isSaveInfoCustomer) {
      const saveInfoCustomer = {
        [FIELD_CUSTOMER.TEN]: data[ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN.field],
        [FIELD_CUSTOMER.MST]: data[ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field],
        [FIELD_CUSTOMER.DCHI]: data[ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field],
        [FIELD_CUSTOMER.MA]: data[ISSUE_INVOICE_BUYER_FIELD.NMUA_MKHANG.field],
        [FIELD_CUSTOMER.SDTHOAI]:
          data[ISSUE_INVOICE_BUYER_FIELD.NMUA_SDTHOAI.field],
        [FIELD_CUSTOMER.DCTDTU]:
          data[ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field],
        [FIELD_CUSTOMER.STKNHANG]:
          data[ISSUE_INVOICE_BUYER_FIELD.NMUA_STKNHANG.field],
        [FIELD_CUSTOMER.TNHANG]:
          data[ISSUE_INVOICE_BUYER_FIELD.NMUA_TNHANG.field],
        [FIELD_CUSTOMER.TYPE_ID]: "1", // 1 doanh nghiệp, 2 khách lẻ
      };
      yield call(CustomerService.createCustomer, saveInfoCustomer);
    }
    if (auto_sign === 1) {
      payload.data["auto_sign"] = auto_sign;
      payload.data["integrate_release_mode"] = "DEFAULT";
    }
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        IssueInvoiceService.editIssueInvoiceTickets,
        payload.data,
        id
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        IssueInvoiceService.editDeliveryBill,
        payload.data,
        id
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(
        IssueInvoiceService.editWarehouseAgency,
        payload.data,
        id
      );
    } else {
      response = yield call(
        IssueInvoiceService.editIssueInvoice,
        payload.data,
        id
      );
    }
    if (auto_sign === 1) {
      yield put(
        backupDataNew({
          id,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_RELEASE,
        })
      );
    }
    // Wait XML generate
    yield sleep(1);
    yield put(editIssueInvoiceSuccess(response));
  } catch (error) {
    yield put(editIssueInvoiceFail(errorMessage(error)));
  }
}

function* fetchDownloadXmlIssueInvoice({
  resource_id,
  fileDownloadName,
  responseType = "blob",
  typeInvoiceAnother,
  typeFile = ".xml",
}) {
  try {
    let response = null;
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        IssueInvoiceService.downloadFileXMLIssueInvoiceTickets,
        resource_id,
        responseType
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        IssueInvoiceService.downloadFileXMLDeliveryBill,
        resource_id,
        responseType
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(
        IssueInvoiceService.downloadFileXMLWarehouseAgency,
        resource_id,
        responseType
      );
    } else {
      response = yield call(
        IssueInvoiceService.downloadFileXMLIssueInvoice,
        resource_id,
        responseType
      );
    }
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);
          yield put(
            downloadXmlIssueInvoiceSuccess(
              null,
              file,
              fileDownloadName + typeFile
            )
          );
        } else {
          yield put(downloadXmlIssueInvoiceFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlIssueInvoiceSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + typeFile
          )
        );
      }
    } else {
      yield put(downloadXmlIssueInvoiceFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlIssueInvoiceFail(error));
  }
}

function* loadConfigInvoiceField({}) {
  try {
    let businessUnitInfo = null;
    let listCurrency = [];
    let listVat = [];
    let listPaymentMethod = [];

    const responseVat = yield call(IssueInvoiceService.listVats);
    const responsePay = yield call(IssueInvoiceService.listPaymentMethods);
    const responseCur = yield call(IssueInvoiceService.listCurrencies);
    // const responseBus = yield call(IssueInvoiceService.getBusinessUnits);
    if (responseVat) {
      listVat = responseVat.items.map(item => {
        return {
          value: item.tsuat,
          label: item.ltsuat,
          id: item.id,
        };
      });
    }
    // if (responseBus) {
    //   businessUnitInfo = responseBus.items[0];
    // }
    if (responsePay) {
      listPaymentMethod = responsePay.items.map(item => {
        return {
          value: item.htttoan,
          label: item.htttoan,
          id: item.id,
        };
      });
    }
    // Nếu có VND thì move lên đầu
    let defaultVND = {
      value: "VND",
      label: "VND",
    };
    if (responseCur) {
      let items = responseCur.items.map(item => {
        return {
          value: item.dvtte,
          label: item.dvtte,
        };
      });
      if (!items.filter(item => item.label === "VND") || items.length === 0) {
        items.push(defaultVND);
      }
      items = items.sort((x, y) => {
        return x.label == "VND" ? -1 : y.label == "VND" ? 1 : 0;
      });
      listCurrency = items;
    } else {
      // K có thì mặc dịnh VND
      listCurrency = [defaultVND];
    }
    yield put(
      loadConfigInvoiceFieldSuccess(
        businessUnitInfo,
        listCurrency,
        listVat,
        listPaymentMethod
      )
    );
  } catch (error) {
    yield put(loadConfigInvoiceFieldFail(errorMessage(error)));
  }
}

function* getEnterpriseByTaxCode({ taxCode }) {
  try {
    const response = yield call(
      IssueInvoiceService.getEnterpriseByTaxCode,
      taxCode
    );
    if (response) {
      yield put(getEnterpriseByTaxCodeSuccess({ taxCode, ...response }));
    } else {
      yield put(getEnterpriseByTaxCodeFail("getEnterpriseByTaxCodeFail error"));
    }
  } catch (error) {
    yield put(getEnterpriseByTaxCodeFail(errorMessage(error)));
  }
}

function* fetchReleaseIssueInvoice({
  id,
  typeSend,
  typeInvoiceAnother,
  transferData,
  isCreateAdjust,
  idAdjust,
}) {
  try {
    let responseCheckStatus = null;
    // Check điều kiện khi phát hành hóa đơn
    if (typeInvoiceAnother !== TYPE_INVOICE_ANOTHER.INVOICE_TOTAL) {
      responseCheckStatus = yield call(
        IssueInvoiceService.checkInvoiceStatus,
        id
      );
      if (responseCheckStatus.invoice.auth_status !== AUTH_STATUS_NEW) {
        yield put(
          releaseIssueInvoiceFail(
            "Hóa đơn đã được gửi phát hành, bạn không được quyền phát hành"
          )
        );
        return;
      }
    }
    let response = null;
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        IssueInvoiceService.releaseIssueInvoiceTicket,
        id,
        typeSend
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        IssueInvoiceService.releaseDeliveryBill,
        id,
        typeSend
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(
        IssueInvoiceService.releaseWarehouseAgency,
        id,
        typeSend
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TOTAL) {
      const result = yield call(
        IssueInvoiceService.releaseInvoiceTotal,
        transferData
      );
      response = {
        result: result,
      };
    } else {
      response = yield call(
        IssueInvoiceService.releaseIssueInvoice,
        id,
        typeSend
      );
    }
    let adjustAll = null;
    if (response.result) {
      yield put(
        backupDataNew({
          ...responseCheckStatus?.invoice,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_RELEASE,
        })
      );
      if (isCreateAdjust) {
        try {
          let responseAdjust = yield call(
            IssueInvoiceService.createIssueInvoiceEnterpriseAdjustAll,
            idAdjust
          );
          adjustAll = responseAdjust?.data;
        } catch (error) {
          console.log(
            "🚀 ~ createIssueInvoiceEnterpriseAdjustAll ~ error",
            error
          );
        }
      }
      // Wait
      yield sleep(1);
      yield put(releaseIssueInvoiceSuccess(adjustAll));
    } else {
      let textObject = "hóa đơn";
      switch (typeInvoiceAnother) {
        case TYPE_INVOICE_ANOTHER.INVOICE_TICKETS:
          textObject = "tem phiếu";
          break;
        case TYPE_INVOICE_ANOTHER.DELIVERY_BILL:
          textObject = "phiếu xuất kho vc nội bộ";
          break;
        case TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY:
          textObject = "phiếu xuất kho gửi bán đại lý";
          break;
        default:
          break;
      }
      let error = `Phát hành ${textObject} thất bại`;
      if (response.min_date) {
        error = `Cần phát hành ${textObject} ngày ${response.min_date} trước khi phát hành ${textObject} này`;
      }
      if (response.max_date) {
        const max_date = moment(response.max_date).format("DD-MM-YYYY");
        error = `Đã có ${textObject} phát hành ngày ${max_date}. Vui lòng  cập nhật ngày lập của ${textObject} hiện tại về ${max_date} hoặc lớn hơn (nhưng phải nhỏ hơn ngày hiện tại).`;
      }
      if (
        response?.message?.ttchung_nlap?.[0] ===
        "Nlap and time system not match"
      ) {
        error =
          "Ký hiệu hóa đơn không hợp lệ với Năm hiện tại, vui lòng cập nhật lại HĐ";
      }
      yield put(releaseIssueInvoiceFail(error));
    }
  } catch (error) {
    yield put(releaseIssueInvoiceFail(error));
  }
}

function sleep(sec) {
  return new Promise(resolve => setTimeout(resolve, sec * 1000));
}

// typeSend
// REGISTER: 1,
// INVOICE: 2,
// HDSS: 3, // Thông báo HD sai sót
// HDTH: 4, // bảng tổng hợp
// WAREHOUSES: 6, //Phiếu xuất kho
function* fetchTransferUsb({ id, typeSend, content }) {
  try {
    const data = {
      id,
      type: typeSend,
      content,
    };
    const response = yield call(IssueInvoiceService.transfer, data);
    if (response.result) {
      yield sleep(1);
      yield put(transferUsbInvoiceSuccess());
    } else {
      yield put(transferUsbInvoiceFail(response?.error?.content));
    }
  } catch (error) {
    yield put(transferUsbInvoiceFail("Gửi phát hành hóa đơn thất bại"));
  }
}

function* fetchGenerateNumberInvoice({ id, typeInvoiceAnother }) {
  try {
    // Check điều kiện khi generate số hóa đơn khi ký usb
    let responseCheckStatus = yield call(
      IssueInvoiceService.checkInvoiceStatus,
      id
    );
    if (responseCheckStatus.invoice.auth_status !== AUTH_STATUS_NEW) {
      yield put(
        generateNumberInvoiceFail(
          "Hóa đơn đã được gửi phát hành, bạn không được quyền ký số và phát hành"
        )
      );
      return;
    }

    let response = null;
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        IssueInvoiceService.generateNumberInvoiceWarehouses,
        id
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(
        IssueInvoiceService.generateNumberWarehouseAgency,
        id
      );
    } else {
      response = yield call(IssueInvoiceService.generateNumberInvoice, id);
    }
    if (response.result) {
      yield put(generateNumberInvoiceSuccess(response.items.resource_id));
    } else {
      yield put(generateNumberInvoiceFail("Generate Number Invoice fail"));
    }
  } catch (error) {
    yield put(generateNumberInvoiceFail("Generate NumberInvoice fail"));
  }
}

function* fetchReplaceIssueInvoice({
  id_root,
  attach_ids,
  data,
  typeInvoiceAnother,
  infoTT32,
}) {
  try {
    const invoice = {
      ...data,
    };
    let response = null;
    // TT32:
    if (infoTT32) {
      let { buStoreHeader, buTenantHeaderInfo } = yield select(
        state => state.Dashboard
      );
      let bu_parent = undefined;
      let bu_code = undefined;
      if (buStoreHeader === ALL_STORE) {
        bu_parent = buTenantHeaderInfo.id;
      } else {
        bu_code = buStoreHeader;
      }
      const invoice = {
        ...data,
        tthdlquan_gchu: infoTT32?.tthdlquan_gchu,
        tthdlquan_shdclquan: infoTT32?.tthdlquan_shdclquan,
        tthdlquan_khmshdclquan: infoTT32?.tthdlquan_khmshdclquan,
        tthdlquan_nlhdclquan: infoTT32?.tthdlquan_nlhdclquan,
        tthdlquan_khhdclquan: infoTT32?.tthdlquan_khhdclquan,
        bu_code,
      };
      switch (infoTT32.modeTT32) {
        case MODE_INVOICE_ACTION.REPLACE:
          response = yield call(
            IssueInvoiceService.replaceIssueInvoiceTT32,
            attach_ids,
            invoice
          );
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          response = yield call(
            IssueInvoiceService.adjustIssueInvoiceTT32,
            attach_ids,
            infoTT32.typeAdjust,
            invoice
          );
        default:
          break;
      }
    } else {
      if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
        response = yield call(
          IssueInvoiceService.replaceIssueInvoiceTickets,
          id_root,
          attach_ids,
          invoice
        );
      } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
        response = yield call(
          IssueInvoiceService.replaceDeliveryBill,
          id_root,
          attach_ids,
          invoice
        );
      } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
        response = yield call(
          IssueInvoiceService.replaceWarehouseAgency,
          id_root,
          attach_ids,
          invoice
        );
      } else {
        response = yield call(
          IssueInvoiceService.replaceIssueInvoice,
          id_root,
          attach_ids,
          invoice
        );
      }
    }

    if (response.result) {
      yield put(
        backupDataNew({
          ...response.data,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_REPLACE,
        })
      );
      yield put(replaceIssueInvoiceSuccess(response.data));
    } else {
      yield put(replaceIssueInvoiceFail(response.error));
    }
  } catch (error) {
    yield put(replaceIssueInvoiceFail("Replace IssueInvoice fail"));
  }
}

function* fetchAdjustIssueInvoice({
  id_root,
  attach_ids,
  adjust_mod,
  data,
  typeInvoiceAnother,
}) {
  try {
    const invoice = {
      ...data,
    };
    let response = null;
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        IssueInvoiceService.adjustIssueInvoiceTickets,
        id_root,
        attach_ids,
        adjust_mod,
        invoice
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        IssueInvoiceService.adjustDeliveryBill,
        id_root,
        attach_ids,
        adjust_mod,
        invoice
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(
        IssueInvoiceService.adjustWarehouseAgency,
        id_root,
        attach_ids,
        adjust_mod,
        invoice
      );
    } else {
      response = yield call(
        IssueInvoiceService.adjustIssueInvoice,
        id_root,
        attach_ids,
        adjust_mod,
        invoice
      );
    }
    if (response.result) {
      yield put(
        backupDataNew({
          ...response.data,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_ADJUST,
        })
      );
      yield put(adjustIssueInvoiceSuccess(response.data));
    } else {
      yield put(adjustIssueInvoiceFail(response.error));
    }
  } catch (error) {
    yield put(adjustIssueInvoiceFail("Adjust IssueInvoice fail"));
  }
}

function* fetchPreviewPdfIssueInvoice({ id, isPolicy, isConvert }) {
  try {
    // Call api
    let response = null;
    if (isPolicy) {
      response = yield call(IssueInvoiceService.pdfReturnGoods, id);
    } else if (isConvert) {
      response = yield call(IssueInvoiceService.pdfConvert, id);
    } else {
      response = yield call(IssueInvoiceService.reviewPdfInvoice, id);
    }
    if (response.result && response.file) {
      const blob = base64toBlob(response.file);
      const url = URL.createObjectURL(blob);
      yield put(previewPdfIssueInvoiceSuccess(url));
    } else {
      yield put(previewPdfIssueInvoiceFail("Không tồn tại file"));
    }
  } catch (error) {
    yield put(previewPdfIssueInvoiceFail(error));
  }
}

function* fetchDeleteIssueInvoice({ id, typeInvoiceAnother }) {
  try {
    // Check điều kiện khi xóa hóa đơn
    let responseCheckStatus = yield call(
      IssueInvoiceService.checkInvoiceStatus,
      id
    );
    if (responseCheckStatus.invoice.auth_status !== AUTH_STATUS_NEW) {
      yield put(
        deleteIssueInvoiceFail(
          "Hóa đơn đã được gửi phát hành, bạn không được quyền xóa"
        )
      );
      return;
    }
    // Call api
    let response = null;

    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
      response = yield call(IssueInvoiceService.deleteInvoiceTickets, id);
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(IssueInvoiceService.deleteDeliveryBill, id);
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(IssueInvoiceService.deleteWarehouseAgency, id);
    } else {
      response = yield call(IssueInvoiceService.deleteInvoice, id);
    }
    yield put(deleteIssueInvoiceSuccess());
  } catch (error) {
    yield put(deleteIssueInvoiceFail(error));
  }
}

function* fetchCancelIssueInvoice({
  listInvoice,
  typeCancel,
  typeInvoiceAnother,
  attach_ids,
}) {
  try {
    // Call api
    let response = null;
    let { buStoreHeader } = yield select(state => state.Dashboard);
    if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        IssueInvoiceService.cancelInvoiceTickets,
        typeCancel,
        listInvoice,
        attach_ids,
        buStoreHeader
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        IssueInvoiceService.cancelDeliveryBill,
        typeCancel,
        listInvoice,
        attach_ids,
        buStoreHeader
      );
    } else if (typeInvoiceAnother === TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY) {
      response = yield call(
        IssueInvoiceService.cancelWarehouseAgency,
        typeCancel,
        listInvoice,
        attach_ids,
        buStoreHeader
      );
    } else {
      response = yield call(
        IssueInvoiceService.cancelInvoice,
        typeCancel,
        listInvoice,
        attach_ids,
        buStoreHeader
      );
    }
    yield put(
      backupDataNew({
        id: listInvoice.length === 1 ? listInvoice[0]?.id : null,
        typeAutoReload: TYPE_AUTO_RELOAD.IS_CANCEL,
      })
    );
    yield put(cancelIssueInvoiceSuccess());
  } catch (error) {
    yield put(cancelIssueInvoiceFail(error));
  }
}

function* onUploadFile({ payload }) {
  try {
    const response = yield call(IssueInvoiceService.uploadFile, payload);
    if (response.id) {
      yield put(uploadAttackFileInvoiceSuccess(response.id));
    } else {
      yield put(uploadAttackFileInvoiceFail("Lỗi uplaod file"));
    }
  } catch (error) {
    yield put(uploadAttackFileInvoiceFail(errorMessage(error), payload.type));
  }
}

function* fetchGetReportWord({ id, typeReport, fileName }) {
  try {
    // Call api
    const response = yield call(
      IssueInvoiceService.getReportWord,
      id,
      typeReport
    );
    if (response) {
      //   const blob = base64toBlob(response.file);
      const url = URL.createObjectURL(response);
      yield put(getInvoiceReportWordSuccess(url, fileName));
    } else {
      yield put(getInvoiceReportWordFail("Không tồn tại file"));
    }
  } catch (error) {
    yield put(getInvoiceReportWordFail(error));
  }
}

function* fetchActionWorkflowIssueInvoice({ id, typeWorkflow, note }) {
  try {
    // Call api
    let action = null;
    switch (typeWorkflow) {
      case TYPE_ACTION_WORKFLOW.SUBMIT:
        action = "submit";
        break;
      case TYPE_ACTION_WORKFLOW.APPROVE:
        action = "approve";
        break;
      case TYPE_ACTION_WORKFLOW.REJECT:
        action = "reject";
        break;
      default:
        break;
    }
    const response = yield call(
      IssueInvoiceService.actionWorkflowInvoice,
      id,
      action,
      note
    );
    yield put(actionWorkflowIssueInvoiceSuccess(typeWorkflow));
  } catch (error) {
    yield put(actionWorkflowIssueInvoiceFail(error, typeWorkflow));
  }
}

function* fetchCreateIssueInvoiceEnterprise({ id, typeClone }) {
  try {
    // Call api
    const response = yield call(
      IssueInvoiceService.createIssueInvoiceEnterprise,
      id,
      typeClone
    );
    console.log(
      "🚀 ~ file: saga.js ~ line 1067 ~ function*fetchCreateIssueInvoiceEnterprise ~ response",
      response
    );
    yield put(createIssueInvoiceEnterpriseSuccess(response?.data));
  } catch (error) {
    yield put(createIssueInvoiceEnterpriseFail(error));
  }
}

function* fetchCreateIssueInvoiceEnterpriseAdjustAll({ id }) {
  try {
    // Call api
    const response = yield call(
      IssueInvoiceService.createIssueInvoiceEnterpriseAdjustAll,
      id
    );
    yield put(createIssueInvoiceEnterpriseAdjustAllSuccess(response?.data));
  } catch (error) {
    yield put(createIssueInvoiceEnterpriseAdjustAllFail(error));
  }
}

function* fetchUploadFileInvoice({ root_id, attach_ids }) {
  try {
    // Call api
    const response = yield call(
      IssueInvoiceService.uploadFileInvoice,
      root_id,
      attach_ids
    );
    if (response && response.result) {
      yield put(uploadFileInvoiceSuccess());
    } else {
      yield put(uploadFileInvoiceFail("Upload biên bản đính kèm thất bại"));
    }
  } catch (error) {
    yield put(uploadFileInvoiceFail(error));
  }
}

function* fetchExportInvoice({ dataExport, fileName, path }) {
  try {
    let { buStoreHeader, buTenantHeaderInfo, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      IssueInvoiceService.exportInvoice,
      dataExport,
      path,
      bu_code,
      bu_parent
    );
    if (response) {
      const url = URL.createObjectURL(response);
      yield put(exportInvoiceSuccess(url, fileName));
    } else {
      yield put(exportInvoiceFail("Xuất hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(exportInvoiceFail(error));
  }
}

function* fetchExportInvoiceTicket({ dataExport, fileName }) {
  try {
    let { buStoreHeader, buTenantHeaderInfo, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      IssueInvoiceService.exportInvoiceTicket,
      dataExport,
      bu_code,
      bu_parent
    );
    if (response) {
      const url = URL.createObjectURL(response);
      yield put(exportInvoiceTicketSuccess(url, fileName));
    } else {
      yield put(exportInvoiceTicketFail("Xuất hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(exportInvoiceTicketFail(error));
  }
}

function* fetchExportInvoiceWarehouse({ dataExport, fileName }) {
  try {
    let { buStoreHeader, buTenantHeaderInfo, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      IssueInvoiceService.exportInvoiceWarehouse,
      dataExport,
      bu_code,
      bu_parent
    );
    if (response) {
      const url = URL.createObjectURL(response);
      yield put(exportInvoiceWarehousesSuccess(url, fileName));
    } else {
      yield put(exportInvoiceWarehousesFail("Xuất hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(exportInvoiceWarehousesFail(error));
  }
}

function* fetchExportInvoiceWarehouseAgency({ dataExport, fileName }) {
  try {
    let { buStoreHeader, buTenantHeaderInfo, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      IssueInvoiceService.exportInvoiceWarehouseAgency,
      dataExport,
      bu_code,
      bu_parent
    );
    if (response) {
      const url = URL.createObjectURL(response);
      yield put(exportInvoiceWarehousesAgencySuccess(url, fileName));
    } else {
      yield put(exportInvoiceWarehousesAgencyFail("Xuất hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(exportInvoiceWarehousesAgencyFail(error));
  }
}

function* fetchInvoiceCampaignList({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    let { finalListBuCode, listBuOfTenant, buStoreHeader, buTenantHeaderInfo } =
      yield select(state => state.Dashboard);
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      IssueInvoiceService.invoiceCampaignList,
      page,
      perPage,
      columnFilter,
      keywords,
      sort,
      bu_parent,
      bu_code
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getInvoiceCampaignListSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getInvoiceCampaignListFail(error));
  }
}

function* fetchUploadCampaignsInvoice({ typeReport, report_id, store_code }) {
  try {
    // Call api
    const response = yield call(
      IssueInvoiceService.uploadCampaignInvoice,
      typeReport,
      report_id,
      store_code
    );
    if (response && response.report_id) {
      yield put(uploadCampaignsInvoiceSuccess(response));
    } else {
      yield put(uploadCampaignsInvoiceFail("Upload lô hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(uploadCampaignsInvoiceFail(error));
  }
}

function* fetchReleaseCampaignInvoice({ id }) {
  try {
    // Call api
    const response = yield call(IssueInvoiceService.releaseCampaignInvoice, id);
    if (response?.result) {
      yield put(releaseCampaignsInvoiceSuccess());
    } else {
      yield put(releaseCampaignsInvoiceFail("Phát hành lô hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(releaseCampaignsInvoiceFail());
  }
}

function* fetchDetailCampaignInvoice({ id }) {
  try {
    // Call api
    const response = yield call(IssueInvoiceService.campaignInvoiceDetail, id);
    if (response) {
      yield put(invoiceCampaignDetailSuccess(response));
    } else {
      yield put(invoiceCampaignDetailFail("Detail lô hóa đơn"));
    }
  } catch (error) {
    yield put(invoiceCampaignDetailFail());
  }
}

function* fetchDataLinkType({ id, isGetChild }) {
  try {
    // Call api
    const response = yield call(
      IssueInvoiceService.getDataLink,
      id,
      isGetChild
    );
    if (response) {
      yield put(getDataLinkSuccess(response, isGetChild));
    } else {
      yield put(getDataLinkFail("Lấy thông tin thất bại"));
    }
  } catch (error) {
    yield put(getDataLinkFail());
  }
}

function* fetchGetMaxDate({ khmhdon, khhdon, bu_code }) {
  try {
    // Call api
    // Get thông tin giới hạn ngày lập được chọn
    let buCode = bu_code;
    if (!buCode) {
      let { buStoreHeader } = yield select(state => state.Dashboard);
      buCode = buStoreHeader;
    }
    let minDate = null;
    let response = yield call(
      IssueInvoiceService.invoiceMaxDate,
      khmhdon,
      khhdon,
      buCode
    );
    if (response && response.result && response.date) {
      minDate = moment(response.date * 1000).format("DD-MM-YYYY");
    } else {
      const currentDate = new Date();
      minDate = moment(new Date(currentDate.getFullYear(), 0, 1)).format(
        "DD-MM-YYYY"
      );
    }
    if (minDate.indexOf("Invalid date") !== -1) {
      const currentDate = new Date();
      minDate = moment(new Date(currentDate.getFullYear(), 0, 1)).format(
        "DD-MM-YYYY"
      );
    }
    if (response) {
      yield put(getInvoiceMaxDateSuccess(minDate));
    } else {
      yield put(getInvoiceMaxDateFail("Lấy thông tin ngày thất bại"));
    }
  } catch (error) {
    yield put(getInvoiceMaxDateFail());
  }
}

function* fetchGetMinDate({ khmhdon, khhdon, bu_code }) {
  try {
    // Call api
    // Get thông tin giới hạn ngày lập được chọn
    let buCode = bu_code;
    if (!buCode) {
      let { buStoreHeader } = yield select(state => state.Dashboard);
      buCode = buStoreHeader;
    }
    let minDate = null;
    let maxDate = null;
    let response = yield call(
      IssueInvoiceService.invoiceMinDate,
      khmhdon,
      khhdon,
      buCode
    );
    let responseMaxDate = yield call(
      IssueInvoiceService.invoiceMaxDate,
      khmhdon,
      khhdon,
      buCode
    );
    if (response && response.result && response.date) {
      minDate = response.date * 1000;
    }
    if (responseMaxDate && responseMaxDate.result && responseMaxDate.date) {
      maxDate = responseMaxDate.date * 1000;
    }
    let resMethodSign = null;
    if (bu_code !== ALL_BU) {
      resMethodSign = yield call(
        DashboardService.getListBUMethodSign,
        bu_code,
        bu_code
      );
      if (resMethodSign && resMethodSign.items) {
        yield put(setMethodSignSuccess(resMethodSign.items));
      }
    }
    if (response || responseMaxDate) {
      const data = {
        minDate,
        maxDate,
      };
      yield put(getInvoiceMinDateSuccess(data));
    } else {
      yield put(getInvoiceMinDateFail("Lấy thông tin ngày thất bại"));
    }
  } catch (error) {
    yield put(getInvoiceMinDateFail());
  }
}

function* fetchDownloadZipInvoice({ ids, typeFile, fileName }) {
  try {
    // Call api
    const response = yield call(IssueInvoiceService.downloadZip, ids, typeFile);
    if (response) {
      const url = URL.createObjectURL(response);
      yield put(downloadZipInvoiceSuccess(url, fileName));
    } else {
      yield put(downloadZipInvoiceFail("Download thất bại"));
    }
  } catch (error) {
    yield put(downloadZipInvoiceFail(error));
  }
}

function* fetchGetCurrentTime() {
  try {
    // Call api
    const response = yield call(IssueInvoiceService.getCurrentTime);
    if (response) {
      const date = new Date(response * 1000).setHours(0, 0, 0, 0);
      const momentDate = moment(date);
      const data = {
        year: momentDate.year(),
        date: date,
        momentDate: momentDate,
      };
      yield put(getCurrentTimeSuccess(data));
    } else {
      yield put(getCurrentTimeFail());
    }
  } catch (error) {
    yield put(getCurrentTimeFail());
  }
}

function* issueInvoiceSaga() {
  yield takeEvery(ISSUE_INVOICE_LIST, fetchListIssueInvoice);
  yield takeEvery(ISSUE_INVOICE_DETAIL, fetchDetailIssueInvoice);
  yield takeEvery(LOAD_CONFIG_INVOICE_FIELD, loadConfigInvoiceField);
  yield takeEvery(GET_ENTERPRISE_BY_TAX_CODE, getEnterpriseByTaxCode);
  yield takeEvery(ISSUE_INVOICE_CREATE, onCreateIssueInvoice);
  yield takeEvery(ISSUE_INVOICE_EDIT, onEditIssueInvoice);
  yield takeEvery(DOWNLOAD_XML_ISSUE_INVOICE, fetchDownloadXmlIssueInvoice);
  yield takeEvery(RELEASE_ISSUE_INVOICE, fetchReleaseIssueInvoice);
  yield takeEvery(TRANSFER_USB_INVOICE, fetchTransferUsb);
  yield takeEvery(GENERATE_NUMBER_INVOICE, fetchGenerateNumberInvoice);
  yield takeEvery(REPLACE_ISSUE_INVOICE, fetchReplaceIssueInvoice);
  yield takeEvery(ADJUST_ISSUE_INVOICE, fetchAdjustIssueInvoice);
  yield takeEvery(PREVIEW_PDF_ISSUE_INVOICE, fetchPreviewPdfIssueInvoice);
  yield takeEvery(DELETE_ISSUE_INVOICE, fetchDeleteIssueInvoice);
  yield takeEvery(CANCEL_ISSUE_INVOICE, fetchCancelIssueInvoice);
  yield takeEvery(CLONE_ENVOICE, getCloneEnvoice);
  yield takeEvery(SEND_MAIL_INVOICE, sendMailInvoice);
  yield takeEvery(ATTACK_FILE_INVOICE_UPLOAD, onUploadFile);
  yield takeEvery(GET_INVOICE_REPORT_WORD, fetchGetReportWord);
  yield takeEvery(
    ACTION_WORKFLOW_ISSUE_INVOICE,
    fetchActionWorkflowIssueInvoice
  );
  yield takeEvery(
    CREATE_ISSUE_INVOICE_ENTERPRISE,
    fetchCreateIssueInvoiceEnterprise
  );
  yield takeEvery(
    CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL,
    fetchCreateIssueInvoiceEnterpriseAdjustAll
  );
  yield takeEvery(UPLOAD_FILE_INVOICE, fetchUploadFileInvoice);
  yield takeEvery(EXPORT_INVOICE, fetchExportInvoice);
  yield takeEvery(EXPORT_INVOICE_TICKET, fetchExportInvoiceTicket);
  yield takeEvery(EXPORT_INVOICE_WAREHOUSES, fetchExportInvoiceWarehouse);
  yield takeEvery(
    EXPORT_INVOICE_WAREHOUSES_AGENCY,
    fetchExportInvoiceWarehouseAgency
  );
  yield takeEvery(INVOICE_CAMPAIGN_LIST, fetchInvoiceCampaignList);
  yield takeEvery(UPLOAD_CAMPAIGNS_INVOICE, fetchUploadCampaignsInvoice);
  yield takeEvery(RELEASE_CAMPAIGNS_INVOICE, fetchReleaseCampaignInvoice);
  yield takeEvery(INVOICE_CAMPAIGN_DETAIL, fetchDetailCampaignInvoice);
  yield takeEvery(GET_DATA_LINK, fetchDataLinkType);
  yield takeEvery(GET_INVOICE_MAX_DATE, fetchGetMaxDate);
  yield takeEvery(GET_INVOICE_MIN_DATE, fetchGetMinDate);
  yield takeEvery(DOWNLOAD_ZIP_INVOICE, fetchDownloadZipInvoice);
  yield takeEvery(GET_CURRENT_TIME, fetchGetCurrentTime);
}

export default issueInvoiceSaga;
